import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { CORES } from "../utils/participante";

// Pagina publica aberta pelo link "aceitar convite" do e-mail.
const AceitarConvite = () => {
  const { codigoConvite } = useParams();
  const [status, setStatus] = useState("carregando");
  const [mensagem, setMensagem] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/participantes/aceitar-convite/${codigoConvite}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          setStatus("sucesso");
          setMensagem(data.message);
        } else {
          setStatus("erro");
          setMensagem(data.error || "Erro ao confirmar o convite.");
        }
      })
      .catch(() => {
        setStatus("erro");
        setMensagem("Erro ao conectar com o servidor.");
      });
  }, [codigoConvite]);

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 6,
        backgroundColor: CORES.fundo,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 440,
          backgroundColor: "#fff",
          border: `1px solid ${CORES.borda}`,
          borderRadius: "10px",
          px: { xs: 3, sm: 4 },
          py: 5,
          textAlign: "center",
        }}
      >
        {status === "carregando" && (
          <>
            <CircularProgress size={34} sx={{ color: CORES.navy }} />
            <Typography sx={{ fontSize: 18, fontWeight: 700, color: CORES.navy, mt: 2.5 }}>
              Confirmando seu convite…
            </Typography>
            <Typography sx={{ fontSize: 13, color: CORES.textoSuave, mt: 0.75 }}>
              Aguarde um momento enquanto processamos sua confirmação.
            </Typography>
          </>
        )}

        {status === "sucesso" && (
          <>
            <CheckCircleRoundedIcon sx={{ fontSize: 52, color: CORES.verde }} />
            <Typography sx={{ fontSize: 22, fontWeight: 800, color: CORES.navy, mt: 1.5 }}>Convite confirmado!</Typography>
            <Typography sx={{ fontSize: 13.5, color: CORES.textoSuave, mt: 1 }}>{mensagem}</Typography>
            <Box
              sx={{
                mt: 3,
                px: 2,
                py: 1.5,
                borderRadius: "8px",
                backgroundColor: "#f3f6f9",
                fontSize: 13,
                color: CORES.navyClaro,
              }}
            >
              O QR Code foi enviado para o seu e-mail. Apresente-o na entrada do evento.
            </Box>
          </>
        )}

        {status === "erro" && (
          <>
            <ErrorRoundedIcon sx={{ fontSize: 52, color: CORES.vermelho }} />
            <Typography sx={{ fontSize: 22, fontWeight: 800, color: CORES.navy, mt: 1.5 }}>Algo deu errado</Typography>
            <Typography sx={{ fontSize: 13.5, color: CORES.textoSuave, mt: 1 }}>{mensagem}</Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default AceitarConvite;
